<template>
  <div class="main-wrapper register-surv">
    <div class="container-fluid">
      <div class="login-wrapper">
        <header class="logo-header"></header>

        <div class="login-inbox">
          <div class="log-auth">
            <div class="login-auth-wrap">
              <h3>Login</h3>
              <p class="text-danger" v-if="formError">{{ formError }}</p>
            </div>

            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <div class="form-group">
                <label class="form-label">Email Address <span>*</span></label>

                <Field
                  name="email"
                  type="text"
                  value=""
                  class="form-control"
                  :class="{ 'is-invalid': errors.email }"
                />

                <div class="invalid-feedback">{{ errors.email }}</div>
                <div class="emailshow text-danger" id="email"></div>
              </div>

              <div class="form-group">
                <label class="form-label">Password <span>*</span></label>
                <div class="pass-group">
                  <Field
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    value=""
                    class="form-control pass-input mt-2"
                    :class="{ 'is-invalid': errors.password }"
                  />

                  <span @click="toggleShow" class="toggle-password">
                    <i :class="{
                      'fas fa-eye': showPassword,
                      'fas fa-eye-slash': !showPassword,
                    }"
                    ></i>
                  </span>

                  <div class="invalid-feedback">{{ errors.password }}</div>
                  <div class="emailshow text-danger" id="password"></div>
                </div>
              </div>

              <div class="form-group form-remember d-flex align-items-center justify-content-between">
                <div class="form-check d-flex align-items-center justify-content-start ps-0">
                  <label class="custom-check mt-0 mb-0">
                    <span class="remember-me">Remember Me</span>
                    <input type="checkbox" name="remember" @change="remember = $event.target.checked"/>
                    <span class="checkmark"></span>
                  </label>
                </div>

                <span class="forget-pass">
                  <router-link to="forgot-password"> Forgot Password </router-link>
                </span>
              </div>

              <div class="mb-5">
                <button type="submit" class="btn btn-primary w-100 btn-size flex align-items-center justify-content-center">
                  <div v-if="loading" class="loading-spinner me-2"></div>
                  <span v-else>Login</span>
                </button>
              </div>

              <div class="bottom-text text-center">
                <p>
                  Don’t have account?
                  <router-link to="register">Sign up</router-link>
                </p>
              </div>

              <div class="bottom-text text-center">
                <p>
                  <a :href="websiteUrl">Go to Website</a>
                </p>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Form, Field} from "vee-validate";
import * as Yup from "yup";
import config from '../../../config.js';

export default {
  components: {
    Form,
    Field,
  },

  data() {
    return {
      loading: false,
      remember: false,
      email: '',
      password: '',
      showPassword: false,
      emailError: "",
      passwordError: "",
      formError: '',
    };
  },

  computed: {
    websiteUrl() {
      return config.WEBSITE_URL;
    },

    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },

  mounted() {
    if (this.$route.query.activation) {
      this.$router.replace({ path: '/reset-password', query: {activation: this.$route.query.activation} });
    }
  },

  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    async onSubmit(values) {
      this.loading = true;
      this.formError = '';
      this.emailError = '';
      this.passwordError = '';

      const response = await this.$store.dispatch('auth/login', {
        email: values.email, password: values.password, remember: this.remember,
      });

      this.loading = false;
      if (!response.success) {
        this.formError = response.message || 'Invalid credentials';
        return;
      }

      window.location.href = '/chats';
    },
  },

  setup() {
    const schema = Yup.object().shape({
      email: Yup.string().required("Email is required").email("Email is invalid"),
      password: Yup.string().required("Password is required"),
    });

    return {
      schema,
    };
  },
};
</script>
